<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-hover table-sm no-bor">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{$t('year')}}</th>
                            <th class="text-right">{{$t('total_purchase_amount')}}</th>
                            <th class="text-right">{{$t('total_purchase_payment_amount')}}</th>
                            <th class="text-right">{{$t('total_purchase_return')}}</th>
                            <th class="text-right">{{$t('total_purchase_ap_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index" :class="{'bg-info':ret.Year==year}">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Year}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                            <td class="text-right">{{$money(ret.TotalPayment)}}</td>
                            <td class="text-right">{{$money(ret.TotalReturn)}}</td>
                            <td class="text-right">{{$money(ret.TotalAP)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.TotalAmount)}}</th>
                            <th class="text-right">{{$money(summary.TotalPayment)}}</th>
                            <th class="text-right">{{$money(summary.TotalReturn)}}</th>
                            <th class="text-right">{{$money(summary.TotalAP)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                year: new Date().getFullYear(),
                records: [],
                summary: {
                    TotalAmount: 0,
                    TotalReturn: 0,
                    TotalPayment: 0,
                    TotalAP: 0
                }
            }
        },
        created(){
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                var req = {};
                this.$api().post('report/purchase/yearly', req).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Summaries;
                        this.calcualate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calcualate(){
                var total = 0;
                let sreturn = 0;
                var payment = 0;
                let ap = 0;
                this.records.map(el => {
                    total += el.TotalAmount;
                    sreturn += el.TotalReturn;
                    payment += el.TotalPayment;
                    ap += el.TotalAP;
                });
                this.summary.TotalAmount = total;
                this.summary.TotalReturn = sreturn;
                this.summary.TotalPayment = payment;
                this.summary.TotalAP = ap; 
            }
        }
    }
</script>
